
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"-467 268 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-454.2 290.8c-3.3 0-5.9-2.6-5.9-5.9 0-3.3 2.7-5.9 5.9-5.9 3.3 0 5.9 2.6 5.9 5.9 0 3.2-2.6 5.9-5.9 5.9z","fill":"#131832"}}),_c('linearGradient',{attrs:{"id":"a","gradientUnits":"userSpaceOnUse","x1":"-453.915","y1":"295.409","x2":"-453.915","y2":"270.511","gradientTransform":"matrix(1 0 0 -1 0 562)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#ffd01f"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#f2a767"}})]),_c('path',{attrs:{"d":"M-459.8 280.9c-.1-.2-.3-.5-.3-.8-.7-2.3 1.5-4.8 1.5-4.8h.1s.1 0 0 .1c-.2.4-.1.9.1 1.3.1.2.4.4.6.5-.1-.8.1-1.8.3-2.5.1-.5.4-1 .7-1.4.3-.4.7-.8 1.2-1.2h.1c-.2.6-.3 1.1-.1 1.7.1.2.1.6.4.7-.1-.3 0-.7 0-1 0-.4.1-.8.2-1.2.2-.9.5-1.7 1-2.5.4-.7-.4 1 .2.5.3-.2.6-.5.9-.7.3-.2.6-.4.9-.5.1 0 .1.1 0 .1-1.3 1.9 0 0 0 0-.3.4-.5.9-.7 1.3-.2.5 1-1.5 1-1-.1.5-.1 1 0 1.5 0 .2.1.5.2.7 0 .1.1.3.2.4l.1.1c.1-.5.3-.9.7-1.3.1-.2.3-.3.5-.4.2-.1.5-.1.7-.2 0 0 .1.1 0 .1-.4.5-.3 1.2-.2 1.8l.3 1.8c.1.5.2 1.1.2 1.6 0 .4-.2.9-.5 1.2.1 0 .3-.1.3-.1.2-.1.4-.3.5-.4.2-.2.3-.4.4-.6 0 0 0-.1.1-.1v-.1c0-.1.1-.3.1-.4 0-.1.1-.1.1 0 .2.3.3.7.3 1.1 0 .3 0 .6-.1 1 .1 0 .2 0 .2-.1.3-.1.6-.2.8-.1-.3.2-.5.5-.6.8-.2.4-.2.7-.1 1.1V279.2c0 .1.1.2.1.2.1.1.2.1.3-.1 0-.1 0-.1.1-.2.1.3.1.6.1.9 0 .3 0 .7-.1 1 0 .3-.2.7-.3 1l-.3.6c0 .1-.1.1-.1.1.8 2.4.1 5.1-1.8 6.9-2.7 2.6-7 2.4-9.6-.3-2.3-2.3-2.5-5.8-.7-8.4zm5.6 9.2c3 0 5.4-2.4 5.4-5.4 0-.7-.1-1.3-.3-1.9-.8-2.1-2.8-3.5-5.1-3.5-1.9 0-3.7 1-4.6 2.6a5.376 5.376 0 004.6 8.2z","fill":"url(#a)"}}),_c('path',{attrs:{"d":"M-457.3 284.8l2.1 2 4-3.9","fill":"none","stroke":"#f9bb45","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    